export default __webpack_public_path__ + "static/media/flow.591af3c7.jpg";